import React from 'react';
import styled from 'styled-components';

import { ReactComponent as Logo } from './logo.svg';
import { ReactComponent as HamburgerBars } from './bars-solid.svg';
import { ReactComponent as Close } from './times-solid.svg';
import LinkWrap from '../link_wrap';

class FlyoutMenu extends React.Component {
  constructor(props) {
    super(props);
    this.toggleFlyout = this.toggleFlyout.bind(this);
    this.state = { flyoutVisible: false, theme: props.theme, navItems: props.navItems };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      navItems: props.navItems,
      theme: props.theme,
    };
  }

  toggleFlyout(evt) {
    evt.preventDefault();
    const current = this.state.flyoutVisible;
    this.setState({ flyoutVisible: !current });
  }

  render() {
    const toggleClasses = ['toggle'];
    toggleClasses.push('theme-' + this.state.theme);

    return (
      <>
        <button
          className={toggleClasses.join(' ')}
          type="button"
          aria-label="Toggle navigation"
          onClick={this.toggleFlyout}
        >
          <HamburgerBars></HamburgerBars>
        </button>
        <div
          aria-label="Close menu"
          className={'menu-flyout-fade-screen ' + (this.state.flyoutVisible ? 'visible' : 'hidden')}
          onClick={this.toggleFlyout}
          role="dialog"
        ></div>
        <div className={'menu-flyout ' + (this.state.flyoutVisible ? 'visible' : 'hidden')}>
          <div className="mobile-header">
            <Logo className="logo"></Logo>
            <button onClick={this.toggleFlyout} className="closer">
              <Close></Close>
            </button>
          </div>
          <ul>
            {this.state.navItems.map((v, i) => {
              if (v.link && v.name) {
                return (
                  <li key={i} className={v.accent ? 'accent' : ''}>
                    <LinkWrap to={v.link}>{v.name}</LinkWrap>
                  </li>
                );
              } else {
                return (
                  <li key={i}>
                    <Spacer height={v.height}>&nbsp;</Spacer>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </>
    );
  }
}

const Spacer = styled.div`
  height: ${(props) => props.height}rem;
`;

export default FlyoutMenu;
